@if (booking) {
  <div class="">
    <!-- Main header -->
    <div class="flex h-16 items-center justify-between border-b border-gray-200 p-4">
      <div class="flex items-center">
        <i class="pi pi-user mr-3 text-xl text-primary"></i>
        <h5 class="m-0 text-lg font-medium text-gray-800 dark:text-gray-300">{{ 'booking.detail.personalInfo' | translate }}</h5>
      </div>
    </div>

    <!-- Form content -->
    <div class="p-4">
      <!-- Basic Personal Info - Connected group -->
      <div class="mb-7">
        <div class="mb-3 flex items-center">
          <i class="pi pi-id-card mr-2 text-primary"></i>
          <h6 class="text-md m-0 font-medium text-gray-700 dark:text-gray-300">{{ 'booking.detail.basicInfo' | translate }}</h6>
        </div>
        <div class="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
          <div class="grid">
            <!-- Name -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="guest-name"
                class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                {{ 'booking.detail.name' | translate }} <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                type="text"
                id="guest-name"
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('name') }"
                [(ngModel)]="booking.name"
                (ngModelChange)="onFieldChange('name', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Email -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="guest-email"
                class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                {{ 'booking.detail.email' | translate }} <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                type="email"
                id="guest-email"
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('email_address') }"
                [(ngModel)]="booking.email_address"
                (ngModelChange)="onFieldChange('email_address', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Gender -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                {{ 'booking.detail.gender' | translate }}
              </label>
              <div class="flex gap-4">
                @for (gender of genders; track gender.id) {
                  <div class="align-items-center flex">
                    <p-radioButton
                      [inputId]="'gender-' + gender.id"
                      [value]="gender.id"
                      [(ngModel)]="selectedGenderId"
                      (onClick)="onFieldChange('gender', { id: gender.id, iri: gender.iri })"
                      [disabled]="loading"
                    >
                    </p-radioButton>
                    <label
                      [for]="'gender-' + gender.id"
                      class="ml-2 cursor-pointer text-sm text-gray-700 dark:text-gray-300"
                    >
                      {{ gender.name | translate }}
                    </label>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="mb-7">
        <div class="mb-3 flex items-center">
          <i class="pi pi-phone mr-2 text-primary"></i>
          <h6 class="text-md m-0 font-medium text-gray-700 dark:text-gray-300">{{ 'booking.detail.contactInfo' | translate }}</h6>
        </div>
        <div class="rounded-lg bg-gray-50 p-4 dark:bg-gray-800 ">
          <div class="grid">
            <!-- Phone -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="phone-number"
                class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                {{ 'booking.detail.phoneNumber' | translate }}
              </label>
              <input
                pInputText
                type="text"
                id="phone-number"
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('phone_number') }"
                [(ngModel)]="booking.phone_number"
                (ngModelChange)="onFieldChange('phone_number', $event)"
                [disabled]="loading"
              />
              <small class="mt-1 block text-gray-500 dark:text-gray-300">{{ 'booking.detail.phoneFormat' | translate }}</small>
            </div>

            <!-- Nationality -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="nationality"
                class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                {{ 'booking.detail.nationality' | translate }}
              </label>
              <app-country-select
                [value]="booking.nationality"
                (valueChange)="booking.nationality = $event || undefined; onFieldChange('nationality', $event)"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('nationality') }"
                [disabled]="loading"
              >
              </app-country-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Note: Billing section has been moved to the billing tab -->
    </div>
  </div>
} @else {
  <div class="card shadow-sm">
    <div class="flex min-h-[300px] flex-col items-center justify-center p-5">
      <div class="mb-4 flex flex-col items-center">
        <i class="pi pi-spin pi-spinner mb-3 text-3xl text-primary"></i>
        <h5 class="text-xl font-medium text-gray-700">{{ 'common.loading' | translate }}</h5>
      </div>
      <p class="text-gray-500">{{ 'booking.detail.loadingPersonalInfo' | translate }}</p>
    </div>
  </div>
}
